<div class="custom-combo-box" (focusout)="onFocusLost($event)" (focusin)="onFocus()" (keyup)="tabOut($event)">
    <li class="dropdown custom-dropdown" dropdown [attr.data-automation-id]="automationId"
        [style.width]="fillWidth ? '100%' : 'auto'">
        <div dropdownToggle class="dropdown-container" [ngClass]="[disabled ? 'disabled' : '']"
            [style.width]="fillWidth ? '100%' : 'auto'">
            <input type="text" autocomplete="off" [disabled]="disabled" [(ngModel)]="inputValue" [maxlength]="maxlength"
                (ngModelChange)="filterData()" (click)="onClick($event)" [class.filter-input] = "inputValue && isFilterComboBox"
                [style.width]="inputWidth ? (inputWidth + 'px') : (fillWidth ? '100%' : 'auto')"
                [style.padding-right] = "paddingRight ? (paddingRight + 'px') : 'inherit'"
                [placeholder]="placeholder" [attr.data-automation-id]="automationId + '-input'" />
            <button [attr.data-automation-id]="automationId + '-toggle-button'" (click)="getAllItems($event)"
                (focusout)="tabOut($event, 'listAllButton')">
                <i *ngIf="isFilterComboBox" class="fa fa-filter fa-times filter-icon"></i>
                <i class="fa fa-caret-down color-grey-10" [class.filter-caret-down]="isFilterComboBox"></i>                
            </button>
        </div>
        <ul *dropdownMenu class="dropdown-menu" [attr.data-automation-id]="automationId + '-dropdown-menu'"
            id="{{id}}" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
            (scroll)="scroll($event)">
            <li *ngFor="let item of items; index as i" (mousedown)="selectItem(item)" class="custom-dropdown-option"
                [ngClass]="[item?.toLowerCase() === selectedItem?.toLowerCase() ? 'selected-option' : '']"
                [attr.data-automation-id]="automationId + '-option-' + i">
                <span>{{value? item[value] : item}}</span>
            </li>
        </ul>
    </li>
</div>